import { isAllowedUri } from '@tiptap/extension-link';

const SCHEME_REGEX = /^[a-z][\w+.-]*:/i;

/**
 * Normalises a user-entered link target so it's safe to navigate to or write into the
 * document.
 *
 * - Trims whitespace; empty input returns null.
 * - Prepends `https://` when the value has no scheme so bare hostnames don't resolve
 *   relative to the current page.
 * - Rejects unsafe schemes (`javascript:`, `vbscript:`, `data:`, etc.) by delegating to
 *   Tiptap's own `isAllowedUri`, so this validator and the Link extension agree on what
 *   counts as a valid link.
 *
 * Returns the normalised href, or null when the value can't be made into a safe link.
 */
export const normalizeLinkHref = (href: string): string | null => {
  const trimmed = href.trim();
  if (!trimmed) {
    return null;
  }

  const candidate = SCHEME_REGEX.test(trimmed) ? trimmed : `https://${trimmed}`;
  return isAllowedUri(candidate) ? candidate : null;
};
